import type { SchemaInput } from '../shared/schema-input.js';
import { isObject } from '../shared/runtime-values.js';
import { t } from './i18n.js';

export class CheckoutRequestError extends Error {
  readonly reason: 'region_restricted' | 'checkout_request_failed';

  constructor(payload: SchemaInput) {
    const restricted = payload !== null && isObject(payload) && 'error' in payload && payload.error === 'service_unavailable_in_region';
    super(t(restricted ? 'upgrade_dialog.region_unavailable' : 'upgrade_dialog.error_something_wrong'));
    this.reason = restricted ? 'region_restricted' : 'checkout_request_failed';
  }
}

export function checkoutFailureReason(cause: unknown): 'region_restricted' | 'checkout_request_failed' | 'checkout_load_timeout' {
  if (cause instanceof CheckoutRequestError) return cause.reason;
  if (cause instanceof Error && cause.message === 'Checkout request timed out') return 'checkout_load_timeout';
  return 'checkout_request_failed';
}

export function checkoutFailureMessage(cause: unknown): string {
  return cause instanceof CheckoutRequestError ? cause.message : t('upgrade_dialog.error_something_wrong');
}
